import styled from 'styled-components';

export default styled.div`
  position: relative;
  color: rgba(72, 53, 198, 1);
  opacity: 1;
  justify-content: center;
  align-items: center;
  z-index: 10;
  max-height: 100%;
  width: 100%;
  height: 100%;
  padding: 1rem;
  overflow: hidden;
  display: flex;
  
  ${props => props.thisStyles && props.thisStyles.wrapper ? props.thisStyles.wrapper : props.thisStyles}

  svg path {
    ${props => props.thisStyles && props.thisStyles.svgPath ? props.thisStyles.svgPath : ''}
  }

`;
